
// @ts-nocheck


export const localeCodes =  [
  "ar",
  "de",
  "en",
  "es",
  "fr",
  "it",
  "pt"
]

export const localeLoaders = {
  ar: [
    {
      key: "locale_ar_45001_46json_396dd44a",
      load: () => import("#nuxt-i18n/396dd44a" /* webpackChunkName: "locale_ar_45001_46json_396dd44a" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46json_e99b12aa",
      load: () => import("#nuxt-i18n/e99b12aa" /* webpackChunkName: "locale_de_45DE_46json_e99b12aa" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_45GB_46json_81439e26",
      load: () => import("#nuxt-i18n/81439e26" /* webpackChunkName: "locale_en_45GB_46json_81439e26" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_077ff8a8",
      load: () => import("#nuxt-i18n/077ff8a8" /* webpackChunkName: "locale_es_45ES_46json_077ff8a8" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_e7a9ad08",
      load: () => import("#nuxt-i18n/e7a9ad08" /* webpackChunkName: "locale_fr_45FR_46json_e7a9ad08" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46json_441d2f8a",
      load: () => import("#nuxt-i18n/441d2f8a" /* webpackChunkName: "locale_it_45IT_46json_441d2f8a" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_45BR_46json_cd596b75",
      load: () => import("#nuxt-i18n/cd596b75" /* webpackChunkName: "locale_pt_45BR_46json_cd596b75" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: true,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ar",
      files: [
        {
          path: "/usr/src/app/i18n/locales/ar-001.json",
          cache: undefined
        }
      ],
      language: "ar-001",
      name: "العربية",
      dir: "rtl"
    },
    {
      code: "de",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de-DE.json",
          cache: undefined
        }
      ],
      language: "de-DE",
      name: "Deutsch"
    },
    {
      code: "en",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en-GB.json",
          cache: undefined
        }
      ],
      language: "en-GB",
      name: "English"
    },
    {
      code: "es",
      files: [
        {
          path: "/usr/src/app/i18n/locales/es-ES.json",
          cache: undefined
        }
      ],
      language: "es-ES",
      name: "Español"
    },
    {
      code: "fr",
      files: [
        {
          path: "/usr/src/app/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ],
      language: "fr-FR",
      name: "Français"
    },
    {
      code: "it",
      files: [
        {
          path: "/usr/src/app/i18n/locales/it-IT.json",
          cache: undefined
        }
      ],
      language: "it-IT",
      name: "Italiano"
    },
    {
      code: "pt",
      files: [
        {
          path: "/usr/src/app/i18n/locales/pt-BR.json",
          cache: undefined
        }
      ],
      language: "pt-BR",
      name: "Português"
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "lang",
    cookieSecure: false,
    fallbackLocale: "es",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://kingsleague.pro",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ar",
    files: [
      {
        path: "/usr/src/app/i18n/locales/ar-001.json",
        cache: undefined
      }
    ],
    language: "ar-001",
    name: "العربية",
    dir: "rtl"
  },
  {
    code: "de",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de-DE.json",
        cache: undefined
      }
    ],
    language: "de-DE",
    name: "Deutsch"
  },
  {
    code: "en",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en-GB.json",
        cache: undefined
      }
    ],
    language: "en-GB",
    name: "English"
  },
  {
    code: "es",
    files: [
      {
        path: "/usr/src/app/i18n/locales/es-ES.json",
        cache: undefined
      }
    ],
    language: "es-ES",
    name: "Español"
  },
  {
    code: "fr",
    files: [
      {
        path: "/usr/src/app/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ],
    language: "fr-FR",
    name: "Français"
  },
  {
    code: "it",
    files: [
      {
        path: "/usr/src/app/i18n/locales/it-IT.json",
        cache: undefined
      }
    ],
    language: "it-IT",
    name: "Italiano"
  },
  {
    code: "pt",
    files: [
      {
        path: "/usr/src/app/i18n/locales/pt-BR.json",
        cache: undefined
      }
    ],
    language: "pt-BR",
    name: "Português"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/